import {Injectable} from '@angular/core'
import {HttpClient} from "@angular/common/http"
import {catchError, map, Observable, of} from "rxjs"
import {AddressModel, AddressRouteModel, CompactAddressModel} from "../../../domain/src/lib/address.model"
import {environment} from "../../../../apps/frontend/src/environments/environment"
import {AppLogger, LoggerService} from "./logger.service"


@Injectable({
  providedIn: 'root',
})
export class AddressService {
  private readonly logger: AppLogger


  constructor(
      private readonly loggerService: LoggerService,
      private readonly http: HttpClient,
  ) {
    this.logger = this.loggerService.create('AddressService')
  }


  getAddresses(active?: boolean): Observable<AddressModel[]> {
    const url = `${environment.apiUrl}/addresses?kind=full&active=${active}`
    return this.http.get<AddressModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  getCompactAddresses(active: boolean | null = null, contactId: number | null = null): Observable<CompactAddressModel[]> {
    const params = new URLSearchParams({
      kind: 'compact',
    })

    if (active !== null) {
      params.set('active', String(active))
    }

    if (contactId !== null) {
      params.set('contactId', String(contactId))
    }

    const url = `${environment.apiUrl}/addresses?${params.toString()}`
    // /addresses?kind=compact&active=${active}
    // /addresses?kind=compact&active=true
    // /addresses?kind=compact&active=false
    // /addresses?kind=compact
    // /addresses?kind=compact&active=true&contactId=${contactId}
    return this.http.get<CompactAddressModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  /*
   getCompactAddressesByContactId(contactId: number): Observable<CompactAddressModel[]> {
   const url = `${environment.apiUrl}/addresses/contacts/${contactId}?kind=compact&active=true`
   return this.http.get<CompactAddressModel[]>(url).pipe(
   map(values => {
   return values
   }),
   )
   }
   */


  getAddressByAddressIds(addressIds: number[]): Observable<AddressModel[]> {
    const url = `${environment.apiUrl}/addresses/${addressIds}`
    return this.http.get<AddressModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  getDescriptions(): Observable<string[]> {
    const url = `${environment.apiUrl}/addresses/descriptions`
    return this.http.get<string[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  addAddress(address: AddressModel, contactId?: number): Observable<any> {
    const url = (contactId) ? `${environment.apiUrl}/addresses?contactId=${contactId}` : `${environment.apiUrl}/addresses`
    // const res = this.http.post(url, address).pipe(
    return this.http.post<number>(url, address).pipe(
        map(value => {
          return value
        }),
    )
  }


  updateAddress(address: AddressModel): Observable<number> {
    const url = `${environment.apiUrl}/addresses/${address.id}`
    return this.http.put<number>(url, address).pipe(
        map(value => {
          return value
        }),
    )
  }


  deleteAddressesByIds(ids: number[]): Observable<any> {
    const url = `${environment.apiUrl}/addresses/${ids}`
    return this.http.delete(url).pipe(
        catchError(this.handleError('deleteAddress')),
    )
  }


  getAddressRoutes(address1Id?: number, address2Id?: number, contactId?: number): Observable<AddressRouteModel[]> {
    if (!address1Id || !address2Id) {
      return of([])
    }
    const url = `${environment.apiUrl}/addresses/routes?address1Id=${address1Id}&address2Id=${address2Id}&contactId=${contactId}`
    return this.http.get<AddressRouteModel[]>(url).pipe(
        map(values => {
          return values
        }),
    )
  }


  addRoute(addressRoute: AddressRouteModel): Observable<any> {
    const url = `${environment.apiUrl}/addresses/routes`
    return this.http.post<number>(url, addressRoute).pipe(
        map(value => {
          return value
        }),
    )
  }


  updateRouteDistance(route: AddressRouteModel): Observable<any> {
    const url = `${environment.apiUrl}/addresses/routes`
    return this.http.patch<number>(url, route).pipe(
        map(value => {
          return value
        }),
    )
  }


  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<boolean> => {
      this.logger.error(error) // log to console instead
      // TODO: better job of transforming error for address consumption
      this.logger.error(`${operation} failed`, 'error=', error.message)
      // Let the app keep running by returning an empty result.
      return of(false)
    }
  }

}
